module.exports = __webpack_public_path__ + "static/img/homepage-bg.61ef8e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index/homepage-bg.jpg
// module id = QAfr
// module chunks = 4